export default __webpack_public_path__ + "static/media/gallery_14.531afbca.jpg";